import { sva } from "@agapi/ui/panda/css";

export const checklistStyles = sva({
  slots: ['root'],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "3",
      position: "relative",
      listStyleType: "none",
    }
  }
});